import styled from "styled-components/macro";

export const SwitchInputStyled = styled.input`
  appearance: none;
  width: 20px;
  height: 12px;
  border-radius: 999px;
  background: var(--Neutral-20);
  position: relative;
  cursor: pointer;
  transition: background 0.3s ease;

  /* Thumb */
  &::after {
    content: "";
    position: absolute;
    top: 1px;
    left: 1px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--White-100);
    transition: transform 0.3s ease;
  }

  /* Checked styles */
  &:checked {
    background: var(--Neutral-100);
  }
  &:disabled {
    cursor: not-allowed;
    background: var(--Neutral-40);
  }

  &:checked::after {
    transform: translateX(8px);
  }
`;

export const SwitchInputStyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  label {
    color: var(--Neutral-100);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
    letter-spacing: -0.014px;
  }
`;
